import { searchMedicationApi } from "../../../services/medication.services";
import {
  searchPharmacyCompaniesApi,
  searchPharmacySaltsApi,
} from "../../../services/pharmacyMedicines.services";
import { getPharmacyConfigListApi } from "../../../services/pharmacyConfigs.services";
import { getCookie } from "../../../helpers/localStorage";
import { ORGANISATONID } from "../../../constants/defaultKeys";

export const fetchMasterMedicines = (text) =>
  searchMedicationApi(
    `query=${encodeURIComponent(text.toLowerCase())}&organization_id=${getCookie(ORGANISATONID)}`
  ).then((res) =>
    (res?.data || [])
      /*
       * A master drug the pharmacy already stocks is not something to add
       * again - offering it here only leads to a duplicate medicine record.
       */
      .filter((item) => !item?.is_pharmacy_medicine)
      .map((item) => {
        const id = item.record_id ?? item.id;
        return {
          value: id,
          label: item.drug1_name
            ? `${item.name} (${item.drug1_name})`
            : item.name,
          name: item.name,
          drug1_name: item.drug1_name || "",
          drug2_name: item.drug2_name || "",
          is_pharmacy_medicine: item.is_pharmacy_medicine,
          current_stock: item.current_stock,
        };
      })
  );

export const fetchSalts = (text) =>
  searchPharmacySaltsApi(`query=${encodeURIComponent(String(text || "").toLowerCase())}`).then((res) =>
    (res?.data || []).map((item) => ({
      value: item.name,
      label: item.name,
    }))
  );

export const fetchHSNAndSAC = (text) =>
  getPharmacyConfigListApi(
    "hsn-and-sac",
    new URLSearchParams({ search: text || "", limit: 50 })
  ).then((res) =>
    (res?.data?.results || []).map((item) => ({
      value: item.tax_code,
      label: `${item.tax_code} (${item.tax_code_type})`,
      /* The code is the carrier of its own GST rate, so the whole record rides
         along - picking a code is what fills the tax fields in, and a second
         request to ask what rate it has would be asking twice. */
      raw: item,
    }))
  );

const fetchConfigOptions = (resource) => (text) =>
  getPharmacyConfigListApi(
    resource,
    new URLSearchParams({ search: text || "", limit: 50 })
  ).then((res) =>
    (res?.data?.results || []).map((item) => ({
      value: item.id,
      label: item.name,
    }))
  );


const fetchCompanyConfigs = fetchConfigOptions("companies");

export const fetchCompanies = (text) =>
  fetchCompanyConfigs(text).then((options) => {
    if (options.length || !text) return options;
    return searchPharmacyCompaniesApi(
      `query=${encodeURIComponent(String(text).toLowerCase())}`
    ).then((res) =>
      (res?.data || []).map((item) => ({
        value: item.record_id,
        label: item.name,
      }))
    );
  });

export const fetchCategories = fetchConfigOptions("categories");
export const fetchItemTypes = fetchConfigOptions("item-types");
